var authEventListener = (function () {

    'use strict';

    /* Public scope and variables */
    var self = {};
    self.settings = {
        'expected_origin': 'https://dauth.supplychain.nhs.uk',
        'expected_data': 'authentication-complete'
    };

    /* Private functions */
    function init() {
        addEventListener();
    }

    function addEventListener() {
        window.addEventListener('message', messageReceived);
    }

    function messageReceived() {
        if (validateMessageOrigin(event.origin))
            if (validateMessageData(event.data))
                postLogInAction();
    }

    function validateMessageOrigin(origin) {
        return origin === self.settings.expected_origin;
    }

    function validateMessageData(data) {
        return data === self.settings.expected_data;
    }

    function postLogInAction() {
        location.reload();
    }

    init();

    return self;

}());